import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { Router, NavigationEnd } from '@angular/router';
import { Notificacao } from '../../../shared/interfaces/notificacao';
import { NotificacaoService, NotificacaoTipoLog } from '../../../shared/services/notificacao.service';
import { BehaviorSubject } from 'rxjs';
import { NotificationDetailComponent } from './notification-detail/notification-detail.component';
import { JwtAuthService } from '../../services/auth/jwt-auth.service';
import { EmpresaContextService } from '../../services/empresa-context.service';
import { CadCompromissoService } from '../../services/cad-compromisso.service';
import { CadCompromisso } from '../../interfaces/cad-compromisso';
import { combineLatest } from 'rxjs';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { NotificacaoAvisoComponent, NotificacaoAvisoData } from './notificacao-aviso/notificacao-aviso.component';
import { notificacaoVisual, textoSimples } from '../../utils/notificacao-render';
import { marcarNotificacaoVista, notificacaoFoiVista } from '../../utils/notificacao-vistas';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html'
})
export class NotificationsComponent implements OnInit {
  @Input() notificPanel;

  // notifications : Notificacao[] = [];
  //change notification to BehaviorSubject
  notifications = new BehaviorSubject<Notificacao[]>([]);
  notificationsLocal = new BehaviorSubject<Notificacao[]>([]);

  notificationsInfokaw = new BehaviorSubject<Notificacao[]>([]);

  notificationsCompromisso = new BehaviorSubject<Notificacao[]>([]);

  /** Quantas ainda não foram abertas neste navegador. */
  totalNovas = 0;

  /** Já avisadas nesta sessão (evita repetir o aviso quando a lista recarrega). */
  private avisadas = new Set<string>();
  private filaAvisos: Notificacao[] = [];
  private avisoAberto = false;
  private avisoRef: MatSnackBarRef<NotificacaoAvisoComponent> | null = null;
  /** O aviso aberto está sendo descartado por troca de empresa (não conta como visto). */
  private descartandoAviso = false;
  private temporizadorAvisos: any = null;

  /**
   * Espera a lista assentar antes de avisar. Ao entrar numa empresa a sessão passa
   * antes pela central (Infokaw) e a lista dela chega primeiro — avisar no calor da
   * troca abria os balões das notificações internas da Infokaw.
   */
  private static readonly ESPERA_AVISOS_MS = 2500;

  /** Empresa (CNPJ) cuja lista está valendo e contador de rodadas de carga. */
  private contexto = '';
  private geracao = 0;

  /** CNPJ e usuário da sessão, para o log de interação (mesmo endpoint do desktop). */
  private logCodigo = '';
  private logUsuario = '';

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private jwtAuth: JwtAuthService,
    private empresaContext: EmpresaContextService,
    private notificacaoService: NotificacaoService,
    private compromissoService: CadCompromissoService,
    private snackBar: MatSnackBar) {}

  ngOnInit() {
    

    combineLatest([
      this.jwtAuth.itemRemoto$,
      this.jwtAuth.item$,
      this.jwtAuth.filial$
    ]).subscribe(([itemRemoto, item]) => {
      // Prefixo "web:" separa no log quem viu pelo navegador de quem viu pelo desktop.
      const login = (item?.usuario?.usuario || item?.userName || '').trim();
      this.logUsuario = login ? `web:${login}` : 'web';

      // console.log(`NOTIFICATIONSCOMPONENT - ITEMREMOTO: ${JSON.stringify(itemRemoto)}`);
      // console.log(`NOTIFICATIONSCOMPONENT - ITEM: ${JSON.stringify(item)}`);
      // console.log(`NOTIFICATIONSCOMPONENT - FILIAL: ${JSON.stringify(filial)}`);

      // Sessão presa na empresa central (Infokaw) sem acesso liberado: as notificações aqui são as
      // internas da central, não têm nada a ver com o usuário. Não carrega nada até ele entrar na
      // empresa correta.
      if (this.empresaContext.isCentralSemAcesso()) {
        this.limpaNotificacoes();
        return;
      }

      // Decide filialCodigo based on empresaRemota presence
      let filialCodigo: string | undefined;

      if (itemRemoto && itemRemoto.filialCodigo) {
        console.log(`NOTIFICATIONSCOMPONENT - FILIALCODIGO FROM ITEMREMOTO: ${itemRemoto.filialCodigo}`);
        filialCodigo = itemRemoto.filialCodigo.replace(/\D/g, '');
        console.log(`NOTIFICATIONSCOMPONENT - FILIALCODIGO AFTER REPLACE: ${filialCodigo}`);
        this.logCodigo = filialCodigo;
        this.loadNotifications(filialCodigo);
      } else if (item && item.filialCodigo) {
        console.log(`NOTIFICATIONSCOMPONENT - FILIALCODIGO FROM ITEM: ${item.filialCodigo}`);
        filialCodigo = item.filialCodigo.replace(/\D/g, '');
        console.log(`NOTIFICATIONSCOMPONENT - FILIALCODIGO AFTER REPLACE: ${filialCodigo}`);
        this.logCodigo = filialCodigo;
        this.loadNotifications(filialCodigo);
      } else {
        console.log(`NOTIFICATIONSCOMPONENT - FILIALCODIGO NOT FOUND`);
        filialCodigo = undefined;
        this.limpaNotificacoes();
      }

    });

    // Merge notificationsLocal, notificationsInfokaw e notificationsCompromisso
    combineLatest([
      this.notificationsLocal,
      this.notificationsInfokaw,
      this.notificationsCompromisso
    ]).subscribe(([local, infokaw, compromissos]) => {
      const itens = [...(local ?? []), ...(infokaw ?? []), ...(compromissos ?? [])];
      const itensUnicos = itens
        .filter((item, index, self) => index === self.findIndex((t) => (t.uuid === item.uuid)))
        .map(item => this.enriquecer(item));
      this.notifications.next(itensUnicos);
      this.setTotalNotif(itensUnicos.length);
      this.enfileirarAvisos(itensUnicos);
    });

    // Update total notifications when notifications change
    this.notifications.subscribe((notificacoes) => {
      this.setTotalNotif(notificacoes.length);
      console.log("TL notificacoes:", notificacoes.length);
    });

    // Close panel on navigation
    this.router.events.subscribe((routeChange) => {
      if (routeChange instanceof NavigationEnd) {
        this.notificPanel.close();
      }
    });
  }

  private limpaNotificacoes() {
    this.trocarContexto('');
    this.notificationsLocal.next([]);
    this.notificationsInfokaw.next([]);
    this.notificationsCompromisso.next([]);
  }

  /**
   * Trocou a empresa: tudo que estava na fila (ou aberto) era da empresa anterior.
   * Descarta sem marcar como vista — na empresa certa ela pode avisar de novo.
   */
  private trocarContexto(codigo: string): boolean {
    this.geracao++;
    if (codigo === this.contexto) {
      return false;
    }
    this.contexto = codigo;
    this.filaAvisos = [];
    clearTimeout(this.temporizadorAvisos);
    if (this.avisoRef) {
      this.descartandoAviso = true;
      this.avisoRef.dismiss();
    }
    return true;
  }

  loadNotifications(filialCodigo: string) {
    if (this.trocarContexto(filialCodigo)) {
      // a lista da empresa anterior sai do sino já, sem esperar a nova chegar
      this.notificationsLocal.next([]);
      this.notificationsInfokaw.next([]);
      this.notificationsCompromisso.next([]);
    }
    // Resposta de uma carga anterior (outra empresa) que chega atrasada não pode
    // sobrescrever a lista atual.
    const geracao = this.geracao;
    const atual = () => geracao === this.geracao;

    // Notificações da API "mesma origem" (nuvem => infokaw.com.br; intranet => /api local).
    this.notificacaoService.getNotificacoesValidas(filialCodigo).subscribe(
      notificacoes => {
        if (!atual()) { return; }
        this.notificationsLocal.next((notificacoes ?? []).map(notificacao => { return { ...notificacao, fromInfokaw: false }; }));
      },
      () => { if (atual()) { this.notificationsLocal.next([]); } }
    );

    // Notificações CENTRAIS da Infokaw (sempre https://infokaw.com.br/api, via getNotificacoesValidasInfokaw).
    // Na intranet o apiURL é local ('/api'), então essa é a única forma de receber os avisos/versão/
    // promoção/cobrança publicados pelo suporte. Sem internet, a chamada falha e mantém só as locais.
    // Na nuvem o resultado coincide com o de cima e é deduplicado por uuid no merge.
    this.notificacaoService.getNotificacoesValidasInfokaw(filialCodigo).subscribe(
      notificacoes => {
        if (!atual()) { return; }
        this.notificationsInfokaw.next((notificacoes ?? []).map(notificacao => { return { ...notificacao, fromInfokaw: true }; }));
      },
      () => { if (atual()) { this.notificationsInfokaw.next([]); } }
    );

    this.compromissoService.getPendentesHoje().subscribe(
      compromissos => {
        if (!atual()) { return; }
        const notifs: Notificacao[] = (compromissos ?? []).map(c => ({
          id: c.id as any,
          uuid: c.uuid ?? `compromisso-${c.id}`,
          titulo: `📋 ${c.titulo}`,
          texto: c.descricao ?? '',
          tipoNotificacao: 'COMPROMISSO' as any,
          tipoNotificacaoTexto: 'TXT' as any,
          desativado: false,
          inicio: c.dataFim ? new Date(c.dataFim) : new Date(),
          issueDate: c.issueDate ? new Date(c.issueDate) : new Date(),
          updatedAt: c.updatedAt ? new Date(c.updatedAt) : new Date(),
          fromInfokaw: false,
          outrosDados: `/utilitario/compromisso/compromisso`,
          _compromisso: c
        } as any));
        this.notificationsCompromisso.next(notifs);
      },
      () => { if (atual()) { this.notificationsCompromisso.next([]); } }
    );
  }

  private setTotalNotif(total = 0) {
    this.notificPanel.totalNotif = total;
  }

  closePanel() {
    this.notificPanel.close();
  }

  clearAll(e) {
    e.preventDefault();
    // Limpar também conta como lido: o aviso de chegada não volta para essas.
    this.notifications.value.forEach(n => marcarNotificacaoVista(n.uuid));
    this.notifications.next([]);
    this.setTotalNotif(0);
    this.totalNovas = 0;
  }

  marcarTodasLidas(e: Event) {
    e.preventDefault();
    this.notifications.value.forEach(n => marcarNotificacaoVista(n.uuid));
    this.atualizarNovas();
  }

  openPopUp(data: Notificacao): MatDialogRef<any> {
    this.closePanel();
    const dialogRef: MatDialogRef<any> = this.dialog.open(NotificationDetailComponent, {
      width: '760px',
      maxWidth: '96vw',
      autoFocus: false,
      panelClass: 'nt-dialog-panel',
      data: { title: '', payload: data }
    });
    this.registrarLog(data, 'BTN_VER');
    dialogRef.afterClosed().subscribe(resultado => {
      // o diálogo fecha com 'acao' quando o usuário clicou no botão/capa da campanha
      if (resultado === 'acao') {
        this.registrarLog(data, 'BTN_ACAO');
      }
      this.atualizarNovas();
    });
    return dialogRef;
  }

  /** Campos só de exibição: aparência do tipo, resumo do texto e marca de nova. */
  private enriquecer(n: Notificacao): Notificacao {
    const item: any = { ...n };
    item._visual = notificacaoVisual(n.tipoNotificacao);
    item._resumo = this.isCompromisso(n) ? '' : textoSimples(n.texto);
    item._nova = !this.isCompromisso(n) && !notificacaoFoiVista(n.uuid);
    return item;
  }

  private atualizarNovas() {
    const lista = this.notifications.value.map(n => this.enriquecer(n));
    this.notifications.next(lista);
  }

  /**
   * Notificação que ainda não foi aberta neste navegador aparece sozinha no canto
   * da tela, uma de cada vez — como o balão do desktop. Compromisso não entra: tem
   * a própria rotina.
   */
  private enfileirarAvisos(lista: Notificacao[]) {
    this.totalNovas = lista.filter((n: any) => n._nova).length;
    clearTimeout(this.temporizadorAvisos);
    // O aviso sai da MESMA lista do sino, depois que ela assenta.
    this.temporizadorAvisos = setTimeout(() => {
      if (!this.contexto) {
        return;
      }
      const naFila = new Set(this.filaAvisos.map(n => n.uuid));
      const novas = this.notifications.value.filter((n: any) =>
        n._nova && n.uuid && !this.avisadas.has(n.uuid) && !naFila.has(n.uuid));
      this.filaAvisos.push(...novas);
      this.proximoAviso();
    }, NotificationsComponent.ESPERA_AVISOS_MS);
  }

  /** Continua no sino da empresa atual? */
  private estaNaLista(n: Notificacao): boolean {
    return this.notifications.value.some(item => item.uuid === n.uuid);
  }

  private proximoAviso() {
    if (this.avisoAberto) {
      return;
    }
    const n = this.filaAvisos.shift();
    if (!n) {
      return;
    }
    if (notificacaoFoiVista(n.uuid) || !this.estaNaLista(n)) {
      this.proximoAviso();
      return;
    }
    this.avisadas.add(n.uuid);
    this.avisoAberto = true;
    const ref = this.snackBar.openFromComponent(NotificacaoAvisoComponent, {
      data: { notificacao: n, restantes: this.filaAvisos.length } as NotificacaoAvisoData,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: 'nt-aviso-panel',
    });
    this.avisoRef = ref;
    ref.afterDismissed().subscribe(({ dismissedByAction }) => {
      this.avisoRef = null;
      if (this.descartandoAviso) {
        // troca de empresa: nem log nem "vista"
        this.descartandoAviso = false;
        this.avisadas.delete(n.uuid);
        this.avisoAberto = false;
        return;
      }
      // "Agora não" também conta: quem dispensou não quer ver o aviso de novo.
      // A notificação continua no sino, só sem a marca de nova.
      marcarNotificacaoVista(n.uuid);
      const seguir = () => {
        this.avisoAberto = false;
        setTimeout(() => this.proximoAviso(), 400);
      };
      if (dismissedByAction) {
        // a fila espera o usuário terminar de ler
        this.openPopUp(n).afterClosed().subscribe(seguir);
      } else {
        this.registrarLog(n, 'BTN_FECHAR');
        this.atualizarNovas();
        seguir();
      }
    });
  }

  private registrarLog(n: Notificacao, tipoLog: NotificacaoTipoLog) {
    this.notificacaoService.registrarLog(n, tipoLog, this.logCodigo, this.logUsuario);
  }

  visual(n: Notificacao) {
    return (n as any)._visual ?? notificacaoVisual(n.tipoNotificacao);
  }
  
  getIconByType(type: string) {
    switch (type) {
      case 'AVISO':       return 'info';
      case 'COBRANCA':    return 'attach_money';
      case 'VERSAO':      return 'update';
      case 'PROMOCAO':    return 'local_offer';
      case 'COMPROMISSO': return 'event';
      default:            return 'notifications';
    }
  }

  getColorByType(type: string) {
    switch (type) {
      case 'AVISO':       return 'accent';
      case 'COBRANCA':    return 'warn';
      case 'VERSAO':      return 'primary';
      case 'PROMOCAO':    return 'accent';
      case 'COMPROMISSO': return 'warn';
      default:            return 'accent';
    }
  }

  isCompromisso(n: Notificacao): boolean {
    return (n.tipoNotificacao as any) === 'COMPROMISSO';
  }

  /** Nome do responsável quando o compromisso está vinculado/preenchido */
  getCompromissoResponsavel(n: Notificacao): string {
    const c = (n as any)._compromisso as CadCompromisso;
    return c?.responsavel?.trim() || '';
  }

  /** Faixa de horário do compromisso (HH:mm – HH:mm), vazio quando sem hora definida */
  getCompromissoHorario(n: Notificacao): string {
    const c = (n as any)._compromisso as CadCompromisso;
    if (!c) return '';
    const ini = this.formatHora(c.dataInicio);
    const fim = this.formatHora(c.dataFim);
    if (ini && fim) return `${ini} – ${fim}`;
    return ini || fim || '';
  }

  private formatHora(d: Date): string {
    if (!d) return '';
    const dt = new Date(d);
    if (isNaN(dt.getTime())) return '';
    const h = dt.getHours();
    const m = dt.getMinutes();
    if (h === 0 && m === 0) return '';
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
  }

}
